import mitt from 'mitt'
import type TtsPlayerEventPayload from "~/libs/interfaces/TtsPlayerEventPayload"

type ApplicationEvents = {
  'stories-content:fullscreen': boolean,
  'tts-player:open': TtsPlayerEventPayload
  'tts-player:init': TtsPlayerEventPayload
};

const emitter = mitt<ApplicationEvents>()

export const useEvent = emitter.emit
export const useListen = emitter.on
